import React, { useState } from "react";
import AppointmentItem from "./appointment";
import arrow from "../../assets/images/arrows_left_icon.png"
import { useHistory } from "react-router-dom";
import { useQuery } from "@apollo/client";
import { useMutation } from "@apollo/client";
import { GET_PHARMACY_PROJECTS } from "queries/queries";
import { SEND_PHARMACY_PROJECT_REQUEST } from "queries/mutations";
import Loading from "components/loading";
import Error from "components/error";
import useMakeScrollable from "custom_hooks/make-scrollable";
import backArrow from '../../assets/images/left_arrow.png';

const AppointmentsSuggestion = ({ }) => {
  useMakeScrollable();
  const {data, loading, error} = useQuery(GET_PHARMACY_PROJECTS, {
    fetchPolicy: "no-cache",
  });
  const [checkedItems, setCheckedItems] = useState({});
  const [message, setMessage] = useState('');
  let history = useHistory();

  const [sendRequestMutation] = useMutation(SEND_PHARMACY_PROJECT_REQUEST, {
    onCompleted: (response) => {
      const isSuccess = response?.sendPharmacyProjectRequest
      if (isSuccess) {
        history.push({
          pathname: '/thank-you',
          state: {
            title: "Vielen Dank für dein Interesse",
            text: "Du wirst per Mail über deinen gewünschten Termin informiert."
          }
        });
      }
    },
    onError: (data) => {
      console.log("error", data);
    },
  });
  
  const handleItemClick = (projectId) => {
    setCheckedItems(prevState => ({
      ...prevState,
      [projectId]: !prevState[projectId]
    }));
  };

  const handleButtonClick = () => {
    const ids = Object.keys(checkedItems).filter(key => checkedItems[key]);
    sendRequestMutation({ variables: { projectIds: ids, message: message } });
  };

  const handleBack = () => {
    history.goBack() 
  };

  if (loading) return <Loading />;
  if (error) return <Error />;

  const suggestedAppointments = data?.getPharmacyProjects
  return (
    <div 
      className="appointments scrollable"
      style={{ paddingTop: "0px" }}
    >
      <div className="appointments-next">
        <img 
          src={backArrow} 
          alt="back" 
          className="points-header-arrow" 
          onClick={handleBack} 
        />
        <div style={{ color: '#707070'}}>Stelle hier deine Anfrage für eine kostenfreie Inhouse-Schulung in deiner Apotheke. Wähle einfach die gewünschte Produktschulung aus, gib deinen Wunschtermin ein und sende die Anfrage ab. Unsere zuständigen Kollegen werden dann mit deiner Apotheke Kontakt aufnehmen.</div>
        {suggestedAppointments.map((project) => (
          <AppointmentItem
            key={project.project.id}
            next={false}
            arrow={''}
            project={project}
            onClick={() => handleItemClick(project.project.id)}
            checked={!!checkedItems[project.project.id]} 
            requestSend={project.requestSend}

          />
        ))}
      </div>
      <div className="appointment-suggestion">
        <div>Wann würde es dir am besten passen?</div>
        <textarea 
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        ></textarea>
      </div>
      <button 
        className="appointment-book-button appointment-suggestion-button"
        onClick={handleButtonClick}
      >Anfrage senden</button>
    </div>
  );
};
  
export default AppointmentsSuggestion;
  